import React, { useEffect, useState } from 'react';
import 'antd/dist/antd.css';
import SelectOption from '../../common/Select';
import { COUNTRY_CODES } from '../../common/constants';
import { Button, Spin, Table } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { getCountryCode, getHostOnboardingData } from './NewHostOnboardingAction';

const NewHostOnboarding = ({ history }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [country, setCountry] = useState('LK');
  const [searchName, setSearchName] = useState(null);
  const newHostOnboarding = useSelector(
    (state) => state.newHostOnboarding?.onboardingData?.data || []
  );
  const countryList = useSelector(
    (state) => state.newHostOnboarding?.countryListDetails?.countryList || []
  );

  const columns = [
    {
      title: 'Organization Name',
      dataIndex: 'company',
      key: 'orgName',
      render: (text) => {
        return text.orgName;
      },
    },
    {
      title: 'Submission Date / Time',
      dataIndex: 'submissionDate',
      key: 'createdDate',
    },
    {
      title: 'Full Name',
      dataIndex: 'contact',
      key: 'fullName',
      render: (text) => {
        return (text.firstName ? text.firstName : '') + (text.lastName ? text.lastName : '');
      },
    },
    {
      title: 'Client Email',
      dataIndex: 'contact',
      key: 'email',
      render: (text) => {
        return text.email;
      },
    },
    {
      title: 'Commission',
      dataIndex: 'commission',
      key: 'commission',
    },
  ];

  useEffect(() => {
    dispatch(getHostOnboardingData(page, pageSize, country, searchName));
  }, []);

  const handlePageChange = (page) => {
    setPage(page);
    dispatch(getHostOnboardingData(page, pageSize, country, searchName));
  };

  const handlePagination = (type) => {
    if (type === 'next' && page >= 1) {
      handlePageChange(page + 1);
    } else if (type === 'prev' && page > 1) {
      handlePageChange(page - 1);
    }
  };

  // const handleCountryFilterOnclick = (country) => {
  //     setCountry(country);
  //     dispatch(getHostOnboardingData(page, pageSize,country, searchName));
  // };

  const navigateToNewHostOnboardingDetails = (record) => {
    history.push(`/dashboard/newHostOnboarding/details?id=${record.id}`);
  };

  return (
    <div>
      <section className="space-listing-section">
        <div className="container">
          <p className="title">New Host Onboarding</p>

          <div className="search-filter-row">
            {/* <div className="search-filter-col">
              <SelectOption
                isMultiple={false}
                label={'Country'}
                name={'Country'}
                placeholder={'Country'}
                values={countryList}
                handleOnSelect={handleCountryFilterOnclick}
                labelName={'name'}
                valueName={'code'}
                defaultValue={COUNTRY_CODES[0].name}
              />
            </div> */}
            <br />
            {newHostOnboarding.fetching ? (
              <>
                <br /> <br /> <br />
                <div className="spin-space-list">
                  <Spin size="large"></Spin>
                </div>{' '}
              </>
            ) : (
              <>
                <Table
                  className="space-listing-table"
                  onRow={(record, rowIndex) => {
                    return {
                      onClick: (event) => {
                        navigateToNewHostOnboardingDetails(record);
                      },
                    };
                  }}
                  dataSource={newHostOnboarding}
                  columns={columns}
                  pagination={false}
                  scroll={{ x: true, y: true }}
                />
                <p className="pagination-wrap">
                  <Button
                    type={'default'}
                    size={'medium'}
                    icon={<LeftOutlined />}
                    onClick={() => {
                      handlePagination('prev');
                    }}
                    disabled={page <= 1}
                  ></Button>
                     {`${page}`}
                  <Button
                    type={'default'}
                    size={'medium'}
                    icon={<RightOutlined />}
                    onClick={() => {
                      handlePagination('next');
                    }}
                    disabled={newHostOnboarding?.length === 0}
                  ></Button>
                </p>
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};
export default NewHostOnboarding;
